import * as React from 'react';
import { ModulesBasic, IPropsBasic, ModulesRoot } from 'kts-scaffold-framework/modules';
import { connect } from 'kts-platform-frame/redux';
import ReduxState, { } from 'kts-platform-frame/redux/ReduxState';
import ModulesState from './Modules.State';
import ModulesAction from './Modules.Action';
import { Button, Icon } from 'antd';

const css = require('./index.scss');

/** Redux接口 */
interface IReduxStatePart {
    
}

/** Props接口 */
interface IProps extends IReduxStatePart, IPropsBasic {

}

/** 绑定全局数据 */
@connect((state: ReduxState): IReduxStatePart => ({

}))
export default class CompanyRegisterSucess extends ModulesBasic<IProps, ModulesState> {

    public state: ModulesState = new ModulesState();

    constructor(props: IProps) {
        super(props, ModulesAction);
    }
    componentDidMount() {
        ModulesAction.countdwon();
    }
    render() {
        return (
            <div className={css.companyRegister}>
                <div className={css.header}>
                    <img src={require('./IMG.LogText.png')}/>
                </div>
                <div className={css.success}>
                <div className={css.details}>
                    <Icon type="check-circle" style={{color: '#B3D465', fontSize: '30px'}}/>
                    <div className={css.countDown}>注册成功，{this.state.countDown}秒后跳转到登录界面</div>
                    <Button 
                        type="primary" 
                        onClick={() => {
                            clearInterval(this.state.timer);
                            ModulesAction.go('/login');
                        }}
                    >
                    点击登陆
                    </Button>
                </div>
                </div>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/display/apps/CompanyRegister/UI.RegisterSuccess.tsx